import React, { SyntheticEvent } from 'react';
import { Dropdown, DropdownItemProps, Modal } from 'semantic-ui-react';
import { ALL_CHARGES } from '../logic/Charges';

interface Props {
    open: boolean;
    onClose: () => void;
    onChange: (charge: string | undefined) => void;
    disabled?: boolean;
}
interface State {
    category: string;
    name?: string;
}

export class ChargeDropdownModal extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            category: "Animals",
            name: "badger statant"
        };

        ChargeDropdownModal.categoryOpts = [];
        ChargeDropdownModal.categoryOpts.push({ key: 'None', value: 'None', text: '- None -' });
        for (const key in ALL_CHARGES) {
            ChargeDropdownModal.categoryOpts.push({ key, value: key, text: key });
        }
    }

    private static categoryOpts: DropdownItemProps[];

    public render() {
        const charges: JSX.Element[] = [];
        const chargeNames = (ALL_CHARGES as any)[this.state.category];
        for (const name of chargeNames) {
            charges.push(<div className="charge-dropdown-modal-inner" key={name}>
                <img src={`https://content.worldspinner.com/heraldry/chargePreviews/${name}.webp`}
                    width="100%" style={{zIndex: "100"}}
                    onClick={() => this.onChangeName(name)} alt={name} />
            </div>);

        }

        return <Modal open={this.props.open}
            onClose={() => this.onClose()} closeIcon="x" closeOnEscape={true} closeOnDimmerClick={true}>
            <Modal.Content>
                <Dropdown selection options={ChargeDropdownModal.categoryOpts} defaultValue={this.state.category}
                    onChange={(event: SyntheticEvent, data: object) => this.onChangeCategory((data as any).value)} />

                <div id="charge-dropdown-modal-outer">
                    {charges}
                </div>
            </Modal.Content>
        </Modal>;
    }

    private onChangeCategory(category: string) {
        // console.log("category: " + category);
        if (category === "None") {
            this.onChangeName(undefined);
        } else {
            this.setState({ category });
        }
    }

    private onChangeName(name: string | undefined) {
        // console.log("Name: " + name);
        this.setState({ name });
        this.props.onChange(name);
        this.props.onClose();
    }

    private onClose() {
        this.props.onClose();
    }
}
